import { CommerceDimensionTable } from "../shared/CommerceDimensionTable";
import { SaleSourceFilter } from "../shared/SaleSourceFilter";
import { StatusFilter } from "../shared/StatusFilter";
import { getColumnValue } from "../utilities/tableHelpers";

export const CommerceMainDimTable = ({
  config,
  visibleColumns,
  filteredRows,
  lookupMaps,
  statuses,
  selectedStatus,
  onStatusChange,
  saleSources,
  selectedSaleSource,
  onSaleSourceChange,
  searchValue,
  onSearchChange,
  onRowClick,
  columnFilters,
  onColumnFilterChange,
}) => (
  <CommerceDimensionTable
    title={config.title}
    statusFilter={
      <StatusFilter
        statuses={statuses}
        selectedStatus={selectedStatus}
        onStatusChange={onStatusChange}
      />
    }
    sourceFilter={
      <SaleSourceFilter
        saleSources={saleSources}
        selectedSaleSource={
          selectedSaleSource
        }
        onSaleSourceChange={
          onSaleSourceChange
        }
      />
    }
    searchValue={searchValue}
    onSearchChange={onSearchChange}
    searchPlaceholder={`Search ${
      config.title ?? ""
    }...`}
    columns={visibleColumns.map(
      (column) => column.label
    )}
    columnDefinitions={visibleColumns}
    data={filteredRows}
    getRowValues={(row) =>
      visibleColumns.map((column) =>
        getColumnValue(
          row,
          column,
          lookupMaps
        )
      )
    }
    onRowClick={onRowClick}
    columnFilters={columnFilters}
    onColumnFilterChange={onColumnFilterChange}
  />
);
